import {} from "react";
import { useApp } from "@/state/app-context";
import { useLongPress } from "./use-long-press";
/**
 * Card-side gesture binding: long-press to enter block multi-select.
 *
 * Reorder flows through the parent dnd-kit `<DndContext>` mounted
 * by `<Stream>`, so this hook no longer owns
 * any drag mechanics. Long-press detection (touch + mouse), the iOS
 * compat-mouse-event suppression, and the touch-tap path all live in
 * the shared `useLongPress` primitive — this wrapper is the
 * block-specific binding (multiselect entry + the consumer's `onTap`
 * for desktop click-to-open).
 *
 * Desktop click-to-open: dnd-kit's `MouseSensor` activates on the
 * first pointer move after mousedown. A click with no movement never
 * crosses the activation threshold, so the event bubbles to the
 * card's `onClick` handler unchanged.
 */
export function useLongPressDrag(cardId, cardRef, options) {
    const app = useApp();
    useLongPress(cardRef, {
        haptic: "medium",
        onLongPress: () => {
            if (app.state.ui.isMultiselectMode)
                return;
            app.enterMultiselectMode(cardId);
        },
        // Only block cards opt into the explicit tap path — they open a
        // centred detail modal whose backdrop can swallow leaked iOS compat
        // mouse events. The shared hook's `touchend.preventDefault()` keeps
        // that from happening (see `use-long-press.ts`).
        onTap: options?.onTap,
    });
}
